export default __webpack_public_path__ + "static/media/arcticslumber.02a74fd6.png";